import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../services/paginatedList';

export type VesselOperationType = {
  id: number;
  name: string;
  color: string;
  notes?: string | null;
  sortOrder: number;
  isActive: boolean;
  rankIds?: number[];
  ranks?: Array<{ id: number; name: string; abrv?: string | null }>;
  createdAt?: string;
  updatedAt?: string;
};

export const useVesselOperationTypes = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<VesselOperationType> | VesselOperationType[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<VesselOperationType>(data, page, limit);
  return {
    data: normalized.data,
    items: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useVesselOperationType = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<VesselOperationType>(
    id != null && Number.isFinite(id) && id > 0 ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
